/* eslint-disable react/display-name */

import React, { useRef, ReactElement } from 'react'

import { useTheme } from 'styled-components'
import { Container } from './styles'

import hydrate from 'next-mdx-remote/hydrate'
import { MdxRemote } from 'next-mdx-remote/types'

import RemarkGfm from 'remark-gfm'
import RemarkAutolink from 'remark-autolink-headings'
import RemarkBreaks from 'remark-breaks'
import RemarkEmoji from 'remark-emoji'
import RemarkEmbed from '@agentofuser/remark-oembed'
import RehypeAutolink from 'rehype-autolink-headings'

import createMarkdownComponents, { markdownComponents } from './components'

interface Props {
  markdown: MdxRemote.Source
  maxWidth?: number
  baseUrl?: string | null
  rootUrl?: string | null
  projectSlug?: string
  currentReadmePath?: string | null
}

const DEFAULT_OPTIONS = {
  remarkPlugins: [
    () => tree => {
      if (!tree || !Array.isArray(tree.children)) return
      const index = tree.children.findIndex(
        node => node?.type === 'heading' && node?.depth === 1
      )
      if (index >= 0) {
        tree.children.splice(index, 1)
      }
    },
    RemarkGfm,
    [
      RemarkAutolink,
      {
        content: {
          type: 'element',
          tagName: 'h2',
          children: [{ type: 'text', value: '#' }],
          properties: { className: ['heading-link'] }
        }
      }
    ],
    RemarkBreaks,
    RemarkEmoji,
    RemarkEmbed
  ],
  rehypePlugins: [RehypeAutolink]
  // compilers: []
}
export { markdownComponents, DEFAULT_OPTIONS }

export default function Markdown({
  markdown,
  maxWidth,
  baseUrl,
  rootUrl,
  projectSlug,
  currentReadmePath
}: Props): ReactElement {
  const rootRef = useRef<HTMLDivElement>()
  const components =
    baseUrl || rootUrl || projectSlug || currentReadmePath
      ? createMarkdownComponents({
          baseUrl,
          rootUrl,
          projectSlug,
          currentReadmePath
        })
      : markdownComponents
  const content = hydrate(markdown, { components })

  return <Container ref={rootRef}>{content}</Container>
}
